import TextareaAutosize from "react-textarea-autosize";
import cx from "../../utils/tailwind-merge";
import { useField, useFormikContext } from "formik";
import FormError from "../form-error";

export const Textarea = (props) => {
  const { ref, className, readOnly, disabled, draggable = false, minRows = 2, ...restProps } = props;
  return (
    <TextareaAutosize
      ref={ref}
      draggable={draggable}
      readOnly={readOnly}
      disabled={disabled}
      className={cx(
        "textarea outline-0 bg-white border-1 text-xs font-normal text-primary-text px-[10px] py-[8px] rounded-lg w-full text-sm leading-[1.75]",
        (readOnly || disabled) && "bg-secondary-250 cursor-not-allowed",
        className,
      )}
      minRows={minRows}
      {...restProps}
    />
  );
};

export default Textarea;

export function FormikTextarea(props) {
  const { name, classNames = {}, setRef = () => { } } = props;
  const [field, meta] = useField(name);
  const { submitCount, validateOnChange, touched } = useFormikContext();
  const isError = (validateOnChange && touched[name] && !!meta.error) || (submitCount > 0 && !!meta.error);
  const helperText = validateOnChange && touched[name] ? meta.error : (submitCount > 0 && meta.error) || "";

  return (
    <>
      <Textarea ref={setRef} error={isError} {...field} {...props} />
      <FormError show={isError} message={helperText} className={classNames.error} />
    </>
  );
}
